module.exports = __webpack_public_path__ + "static/media/91.25536f36.png";